import TableDialogModal from "./TableDialogModal";

export default TableDialogModal;